import { render, staticRenderFns } from "./TemplateActionsMenu.vue?vue&type=template&id=4d936493&scoped=true"
import script from "./TemplateActionsMenu.vue?vue&type=script&lang=js"
export * from "./TemplateActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./TemplateActionsMenu.vue?vue&type=style&index=0&id=4d936493&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d936493",
  null
  
)

export default component.exports